import { Card } from "antd";
import React, { useState } from "react";
import ShiftSchedule from "./shiftSchedule";
import AttendanceLog from "./attendanceLog";
import AttendanceRequest from "./attendanceRequest";
import OverTime from "./overTime";


const HistoryComponent = () => {
    const [activeTabKey2, setActiveTabKey2] = useState<string>('attendanceLog');

    const tabListNoTitle = [
        {
            key: 'attendanceLog',
            label: 'Attendance Log',
        },
        {
            key: 'shiftSchedule',
            label: 'Shift Schedule',
        },
        {
            key: 'attendanceRequest',
            label: 'Attendance Requests',
        },
        {
            key: 'overTime',
            label: 'Over Time',
        },
    ];

    const onTab2Change = (key: string) => {
        setActiveTabKey2(key);
    };

    const contentListNoTitle: Record<string, React.ReactNode> = {
        attendanceLog: <AttendanceLog />,
        shiftSchedule: <ShiftSchedule />,
        attendanceRequest: <AttendanceRequest />,
        overTime: <OverTime />,
    };

    return <Card
        style={{ width: '100%' }}
        tabList={tabListNoTitle}
        activeTabKey={activeTabKey2}
        onTabChange={onTab2Change}
        tabProps={{
            size: 'middle',
        }}
    >
        {contentListNoTitle[activeTabKey2]}
    </Card>
}

export default HistoryComponent;